module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Конвертация валюты":"Currency exchange","Идет поиск...":"Searching...","ваш аккаунт":"your account","Баланс":"Balance","Поиск по корреспонденту":"Search by correspondent","Входящий платеж":"Incoming payment"}}')
  delete Component.options._Ctor
}
